import styled from 'styled-components'

import { useEffect } from 'react'

import { homeLink, loginLink, WithLoginCallbackRoute } from '../../router'
import { SpinnerIcon } from '../Spinner/Spinner'

import type { WithLoginStore } from '../../stores/RootStoreModel'

interface LoginCallbackProps extends WithLoginStore, WithLoginCallbackRoute {}

const LoginCallbackContainer = styled.div`
  inline-size: 100%;
  block-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const gotoLoginPage = () => loginLink.replace()
const gotoHomepage = () => homeLink.replace()

export const LoginCallback = ({ currentRoute, loginStore }: LoginCallbackProps) => {
  useEffect(() => {
    const authorizationCode = currentRoute.params.code
    if (authorizationCode === undefined) {
      // TODO: Maybe display error on screen and put it in loginStore
      console.error('No authorization code present in okta response')
      gotoLoginPage()
      return
    }

    loginStore
      .loginWithAuthorizationCode(authorizationCode)
      .then(() => {
        if (loginStore.loginStatus.isSuccess) {
          gotoHomepage()
        } else {
          gotoLoginPage()
        }
      })
      .catch((err) => {
        console.error('Error while logging in with okta', err)
        gotoLoginPage()
      })
  })
  return (
    <LoginCallbackContainer>
      <div>
        <span>Signing in...</span>
        <SpinnerIcon title="Signing in..." style={{ margin: '1em' }} />
      </div>
    </LoginCallbackContainer>
  )
}
